import { Box, Typography } from "@mui/material"
import type { Row } from "@tanstack/react-table"
import type { ReactElement } from "react"
import { useShallow } from "zustand/shallow"

import type { ProductWithOrder } from "@/screens/Procurement/PurchaseOrders/stores/useProductPurchaseOrdersSearchStore"
import { useUnitOfMeasurementsStore } from "@/stores/unitOfMeasurmentsStore"
import { convertUoMQuantity } from "@/utils/conversion"
import { formatNumber } from "@/utils/number"

export const ProductOrderPriceUomColumn = ({ row }: { row: Row<ProductWithOrder> }): ReactElement => {
  const { uomId, pricePerUom, quantityInUom = 0, product } = row.original

  const uoms = useUnitOfMeasurementsStore(useShallow((s) => s.units))
  const selectedUom = uoms.find((uom) => uom.id === uomId)

  const currentPricing = pricePerUom ? `$${formatNumber(pricePerUom)} / ${selectedUom?.name}` : "Not calculated"

  const converted = convertUoMQuantity(quantityInUom, uomId, product, "package")
  const convertedUom = uoms.find((uom) => uom.id === converted.uomId)?.name

  return (
    // TODO: consider unification with PriceUomColumnReadOnly component
    <Box>
      <Box className='flex gap-2'>
        <Typography className='font-bold'>{currentPricing}</Typography>
        {converted.amount && (
          <Typography variant='caption' className='pt-1'>
            {converted.amount}
          </Typography>
        )}
      </Box>
      <Box className='flex gap-2'>
        <Typography className='font-bold'>{`${quantityInUom} ${selectedUom?.name}`}</Typography>
        <Typography>{`(${converted.amount} ${convertedUom})`}</Typography>
      </Box>
    </Box>
  )
}
